<ng-container *ngFor="let toast of toasts.slice().reverse()">
    <div class="toast-message" [ngClass]="toast.type" >
        <img height="22" width="22" src="{{iconSrcUrl(toast)}}" class="toast-icon">
        <span>{{toast.message}}</span>
        <img src="assets/icons/Icon-Navigation-Exit-Close-Black.svg" class="toast-dismiss" (click)="removeToastById(toast.id)">
    </div>
</ng-container>
